export default "/_next/static/images/medium-1-54590d12f0177ef788479f54e4f5349e.svg";